import { ActionItem } from '@urbanmix-tech/shared-js';

import { ActionItemModal } from './ActionItemModal/ActionItemModal';

export type UnitGeneralModalContentProps = {
  actionItem: ActionItem;
  onChangeModalOpen: (val: boolean) => void;
  onSkipAction: () => void;
  onApproveAction: (payload?: unknown) => Promise<void>;
};

export function UnitGeneralModalContent({
  actionItem,
  onChangeModalOpen,
}: UnitGeneralModalContentProps) {
  if (actionItem.category !== 'general') {
    return null;
  }

  return (
    <ActionItemModal
      actionItem={actionItem}
      onChangeModalOpen={onChangeModalOpen}
    />
  );
}
